import { useState } from 'react';

export const useCustomerForm = (setStep, setCustomerData) => {
  const [paymentMethod, setPaymentMethod] = useState('payment_link');
  const [paymentReference, setPaymentReference] = useState('CASH PAYMENT');
  const [amountPaidUSD, setAmountPaidUSD] = useState('0.000');
  const [amountPaidLocal, setAmountPaidLocal] = useState('0.000');
  const [paymentStatus, setPaymentStatus] = useState('FULLY PAID');

  const onCustomerSubmit = (data) => {
    setCustomerData({
      ...data,
      paymentMethod,
      paymentReference: (paymentMethod === 'cash' || paymentMethod === 'credit_card' || paymentMethod === 'debit_card') ? paymentReference : null,
      amountPaidUSD: (paymentMethod === 'cash' || paymentMethod === 'credit_card' || paymentMethod === 'debit_card') ? amountPaidUSD : null,
      amountPaidLocal: (paymentMethod === 'cash' || paymentMethod === 'credit_card' || paymentMethod === 'debit_card') ? amountPaidLocal : null,
      paymentStatus: (paymentMethod === 'cash' || paymentMethod === 'credit_card' || paymentMethod === 'debit_card') ? paymentStatus : null,
      demoBookingId: data.demoBookingId || null
    });
    setStep('summary');
  };

  return {
    paymentMethod,
    setPaymentMethod,
    paymentReference,
    setPaymentReference,
    amountPaidUSD,
    setAmountPaidUSD,
    amountPaidLocal,
    setAmountPaidLocal,
    paymentStatus,
    setPaymentStatus,
    onCustomerSubmit
  };
};
